import { ProductsScreen } from '../features/products/ProductsScreen'
import { useShell } from '../app/outlet'

export function ProductsPage() {
  const { toast } = useShell()
  return <ProductsScreen onToast={toast} />
}
